import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class DatesManager {

  delay_prod: number = (45 * 60000);
  delay_gas: number = (30 * 60000);
  constructor() { }

  calcProductDate(x: number, y: number) {
    return x - ((y * (60000)) + this.delay_prod);
  }

  calcGasDate(x: number) {
    return x - this.delay_gas;
  }
}
